import dayjs from 'src/utils/dayjs'

export const formatRelativeTime = (t: string) => {
  const time = dayjs(t)

  return time.isBefore(dayjs().subtract(1, 'week'))
    ? time.format('lll')
    : time.fromNow()
}

/** Like {@link formatRelativeTime}, but the absolute fallback omits the time. */
export const formatRelativeDate = (t: string) => {
  const time = dayjs(t)

  return time.isBefore(dayjs().subtract(1, 'week'))
    ? time.format('ll')
    : time.fromNow()
}
